export default "__VITE_ASSET__B6Um6Go3__"